import React from 'react';

const TAG_PATTERN = /\[b\]([\s\S]*?)\[\/b\]|\[i\]([\s\S]*?)\[\/i\]/g;

/**
 * Parses [b]bold[/b] and [i]italic[/i] tags in blog paragraph text.
 */
export function formatBlogText(text: string, isDarkMode = false): React.ReactNode[] {
  const boldCls = isDarkMode ? 'font-bold text-pink-300' : 'font-bold text-pink-600';
  const italicCls = isDarkMode ? 'italic text-pink-300/85' : 'italic text-pink-500';

  const nodes: React.ReactNode[] = [];
  let lastIndex = 0;
  let key = 0;
  let match: RegExpExecArray | null;

  TAG_PATTERN.lastIndex = 0;

  while ((match = TAG_PATTERN.exec(text)) !== null) {
    if (match.index > lastIndex) {
      nodes.push(text.slice(lastIndex, match.index));
    }
    if (match[1] !== undefined) {
      nodes.push(<strong key={key++} className={boldCls}>{match[1]}</strong>);
    } else if (match[2] !== undefined) {
      nodes.push(<em key={key++} className={italicCls}>{match[2]}</em>);
    }
    lastIndex = TAG_PATTERN.lastIndex;
  }

  if (lastIndex < text.length) {
    nodes.push(text.slice(lastIndex));
  }

  return nodes.length > 0 ? nodes : [text];
}
